import { create } from "zustand";

export const useCartStore = create((set, get) => ({
  cart: [],

  updateProductQuantity: (id, quantity) => {
    set((state) => {
      const productIndex = state.cart.findIndex((item) => item.id === id);

      if (productIndex !== -1) {
        // Si el producto ya existe, actualizamos su cantidad
        return {
          cart: state.cart.map((item) =>
            item.id === id ? { ...item, quantity } : item
          ),
        };
      } else {
        // Si no existe, lo agregamos con la cantidad mínima
        return {
          cart: [...state.cart, { id, quantity }],
        };
      }
    });

    console.log("Carrito actualizado:", get().cart); // Debugging para ver si realmente cambia
  },
}));
